import React, { useRef, useEffect, useState } from 'react';
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Checkbox } from 'primereact/checkbox';
import { Col, Container, Form, Row } from 'react-bootstrap';
import { Button } from 'primereact/button';
import SelectStudentMobileTarget from './SelectStudentMobileTarget';

const ShowAbsentStudentList = ({ runClassDate, timeIndexes, onSend, onClose}) => {
    const [loading, setLoading] = useState(true);
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [saving, setSaving] = useState(false);
    const [selectStudentMobileTargetVisible, setSelectStudentMobileTargetVisible] = useState(false);
    const [saveLegalAbsentConfirmVisible, setSaveLegalAbsentConfirmVisible] = useState(false);
    const [items, setItems] = useState([]);
    const [filterdItems, setFilterdItems] = useState([]);
    const [filterText, setFilterText] = useState("");
    const [student, setStudent] = useState(null);
    const [schoolClass, setSchoolClass] = useState(null);
    const LoadingRows = Array.from({length:5});


    useEffect(() => {
        setLoading(true);
        setFilterdItems([])
        var tis = [];
        for(var i=0;i<timeIndexes.length;i++) if(timeIndexes[i]) tis.push(i);
        var params = {login:util.getTrustedUser(), runClassDate:runClassDate, timeIndexes:tis};
        var url = config.Server+`/school/absent-student/list`;
        console.log("timeIndexes is>", timeIndexes);
        console.log("params is>", params);
        console.log("url is>", url);
        axios
            .post(url, params )
            .then(res => {
                var response = res.data;
                if(response.state === "ok"){
                    response = response.data;
                    console.log("response is>", response);
                    
                    setItems(response);
                    setFilterdItems([...response.students]);
                    
                    setLoading(false);
                }
                else{
                    setErrorMessage(response.message);
                    setErorVisible(true);
                    setLoading(false);
                }
            })
            .catch(error => {
                setErrorMessage(error.code + "," + error.message);
                setErorVisible(true);
                setLoading(false);
            });
     
    }, []);

    const editDialogFooter = function(){
        return (
            <>
            <Row className="justify-content-md-center" style={{ direction: "ltr", textAlign:"right" }}>
                <Col style={{textAlign:"rigth"}}>
                    <Button label="انصراف" icon="pi pi-times" outlined onClick={()=>{onClose()}} iconPos="right" />
                </Col>
                <Col style={{textAlign:"left"}}>
                    <Button label="ارسال پیامک" icon="pi pi-check" onClick={()=>{saveItem()}} iconPos="right" severity="success" loading={saving} />
                </Col>                                       
            </Row>
            </>
        )
    }
    const setAsLegalAbsent = function(stu, cls){
        setStudent(stu);
        setSchoolClass(cls);
        setSaveLegalAbsentConfirmVisible(true);
    }
    const onSaveLegalAbsentConfirm_Accept = function(){
        setSaving(true);
        setFilterdItems([])
        var tis = [];
        for(var i=0;i<timeIndexes.length;i++) if(timeIndexes[i]) tis.push(i);
        var params = {login:util.getTrustedUser(), nationalId:student.nationalId, runClassDate:runClassDate, timeIndexes:tis};
        var url = config.Server+`/school/present-absent/set-as-legal`;
        console.log("params is>", params);
        console.log("url is>", url);
        axios
            .post(url, params )
            .then(res => {
                var response = res.data;
                if(response.state === "ok"){
                    
                    var tmp ={...items}; 
                    for(var i=0;i<tmp.students.length;i++){
                        if(tmp.students[i].student.nationalId == student.nationalId){
                            tmp.students.splice(i, 1);
                            console.log("founded index in main is>", i);
                            break;
                        }
                    }
                    setItems(tmp);
                    var tmp2 = [...filterdItems];
                    for(var i=0;i<tmp2.length;i++){
                        if(tmp2[i].student.nationalId == student.nationalId){
                            tmp2.splice(i, 1);
                            console.log("founded index in filter is>", i);
                            break;
                        }
                    }

                    setFilterdItems([...tmp2]);
                    
                    setSaving(false);
                    setSaveLegalAbsentConfirmVisible(false);
                }
                else{
                    setErrorMessage(response.message);
                    setErorVisible(true);
                    setSaving(false);
                }
            })
            .catch(error => {
                setErrorMessage(error.code + "," + error.message);
                setErorVisible(true);
                setSaving(false);
            });

    }
    const setAsLegalAbsentButton = function(row){
        return(
            <Button label="موجه" onClick={()=>{setAsLegalAbsent(row.student, row.schoolClass)}}  severity="success" loading={saving} style={{height:"18px", width:"60px", borderRadius:"5px", paddingRight:"10px"}} />
        )
    }
    const sendSmses = function(studentMobile, parentMobile, create){
        setSaving(true);
        var tis = [];
        for(var i=0;i<timeIndexes.length;i++) if(timeIndexes[i]) tis.push(i);
        var params = {login:util.getTrustedUser(), runClassDate:runClassDate, timeIndexes:tis, studentMobile:studentMobile, parentMobile:parentMobile};
        var url = config.Server+`/school/sms/unleagal-absent/send`;
        if(create) url = config.Server+`/school/mobile-sms/unleagal-absent/create`;
        console.log("params is>", params);
        console.log("url is>", url);
        axios
            .post(url, params )
            .then(res => {
                var response = res.data;
                if(response.state === "ok"){
                    response = response.data;
                    console.log("response is>", response);
                    
                    onSend(response, create);
                    
                    setSaving(false);
                }
                else{
                    setErrorMessage(response.message);
                    setErorVisible(true);
                    setSaving(false);
                }
            })
            .catch(error => {
                setErrorMessage(error.code + "," + error.message);
                setErorVisible(true);
                setSaving(false);
            });
    }
    const saveItem = function(){
        setSelectStudentMobileTargetVisible(true);
    }
    const onFilterTextInputChange = function (e) {
        var val = '';
        val = (e.target && e.target.value) || '';
        setFilterText(val);
        const searchText = val.toString().toLowerCase();

        if((val == null)||(val == '')){
            setFilterdItems(items.students);  
            return; 
        }
        const filteredItems = items.students.filter(item =>
            [
                item.schoolClass.name,
                item.student.nationalId,
                item.student.firstname,
                item.student.lastname,
                item.student.mobile
            ].some(value =>
                value?.toString().toLowerCase().includes(searchText)
            )
        ); 
        setFilterdItems(filteredItems);   
    }
    return (
        <>
            <Dialog visible={true} style={{ width: 'calc(100% - 20px)' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
            header="لیست غایبین غیر موجه" modal className="p-fluid" footer={() => editDialogFooter()} onHide={() => onClose()}>
                <div style={{position:"absolute", top:"10px", right:"230px"}}>
                    <InputText value={filterText} placeholder='جستجو' onChange={(e) => { onFilterTextInputChange(e) }} id="filterdText" keyfilter="" maxLength={100} className="p-inputtext-lg" style={{ width: "100%", textAlign: "right" }} />
                </div>
                <div className="card" style={{overflow:"scroll", marginTop:"10px",minHeight:"calc(100vh - 200px)"}}>
                    {
                    loading?
                            <DataTable value={LoadingRows}  className="p-datatable-striped">
                                <Column field="id" header="کد" style={{ width: '20%' }} body={<Skeleton />}></Column>
                                <Column field="title" header="عنوان" style={{ width: '80%' }} body={<Skeleton />}></Column>
                            </DataTable>
                    :
                        <>
                        <div className='col-12' style={{overflowX:"hidden"}}>
                        <DataTable value={filterdItems} selectionMode={true ? null : 'radiobutton'} scrollable tableStyle={{ minWidth: '50rem' }} size="small" stripedRows 
                        dataKey="id" selection={null}  onSelectionChange={(e) => {}}>
                                <Column header="#" headerStyle={{ width: '3rem' }} body={(data, options) => options.rowIndex + 1}  className="list-cell-text-align"></Column>
                                {config.ShowListId? <Column field="id" header={"شناسه"} sortable className="list-cell-text-align"></Column>: <></>} 
                                <Column field='schoolClass.name' body={(row) => row.schoolClass.name} header={"کلاس"} sortable className="list-cell-text-align"></Column>
                                <Column field='btn' body={(row) => setAsLegalAbsentButton(row)} header={"ولی"} sortable className="list-cell-text-align"></Column>
                                <Column field='student.nationalId' body={(row) => row.student.nationalId} header={"کد ملی"} sortable className="list-cell-text-align"></Column>
                                <Column field='student.firstname' body={(row) => row.student.firstname} header={"نام"} sortable className="list-cell-text-align"></Column>
                                <Column field='student.lastname' body={(row) => row.student.lastname} header={"نام خانوادگی"} sortable className="list-cell-text-align"></Column>
                                {/* <Column field='student.parent.firstname' body={(row) => row.student.parent.firstname} header={"ولی"} sortable className="list-cell-text-align"></Column> */}
                                <Column field='student.mobile' body={(row) => row.student.mobile} header={"موبایل"} sortable className="list-cell-text-align"></Column>
                                {/* <Column field='student.parent.mobile' body={(row) => row.student.parent.mobile} header={"موبایل ولی"} sortable className="list-cell-text-align"></Column> */}
                                <Column field='timeIndexes.length' body={(row) => row.timeIndexes.length} header={"تعداد زنک"} sortable className="list-cell-text-align"></Column>
                        </DataTable>
                        </div>
                        </>
                    }           
                </div>

            </Dialog>
        
            {
                selectStudentMobileTargetVisible?
                <SelectStudentMobileTarget onClose={()=>{setSelectStudentMobileTargetVisible(false);}} onChange={(studentMobile, parentMobile, create)=>{setSelectStudentMobileTargetVisible(false);sendSmses(studentMobile, parentMobile, create);}} />
                :
                <></>
            }
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
            {
                saveLegalAbsentConfirmVisible?
                <>
                <ShowConfirm visible={true} message={"آیا از موجه کردن غیبت "+student.firstname + " " + student.lastname + " با کد ملی " + student.nationalId + " در کلاس " + schoolClass.name + " " + " مطمئن هستید؟"} caption="اطمینان از موجه کردن غیبت" 
                onAccept={()=> onSaveLegalAbsentConfirm_Accept()} onReject={()=> {setSaveLegalAbsentConfirmVisible(false)}} loading={saving} />
                </>
                :
                <></>
            }
        </>
    )
};

export default ShowAbsentStudentList;